import "./DatePicker.scss";

import bulmaCalendar from 'bulma-calendar/dist/js/bulma-calendar.min.js';

import React from "react";
import moment from "moment"

const parseValue = (raw) => {
  if (!raw) return null
  if (raw instanceof Date) return isNaN(raw.getTime()) ? null : raw
  const m = moment(raw)
  return m.isValid() ? m.toDate() : null
}

export default class DatePicker extends React.Component {
  constructor (props) {
    super(props)
    this.state = {}
    this.inputRef = React.createRef()
  }

  componentDidMount() {
    bulmaCalendar.attach(this.inputRef.current, {
      type: this.props.input_type || "date",
      headerPosition: "top",
      showHeader: false,
      dateFormat: "MMM d yyyy",
      timeFormat: "HH:mm",
      minDate: new Date("2020-01-01"),
      displayYearsCount: 6,
    })
    // Seed an existing value via the calendar's own API. bulma-calendar's
    // attach()-time DOM-value parser is strict and silently falls back to
    // today when the format doesn't match the date+time joiner it expects;
    // pushing a Date object through .value()/.save() is the reliable path.
    const seed = parseValue(this.props.value)
    if (seed) {
      this.inputRef.current.bulmaCalendar.value(seed)
      this.inputRef.current.bulmaCalendar.save()
    }
    // Here is the weird trickery to get bulma-calendar with datetime to work properly with React
    // When there is only a date select, the calender never finishes its lifecycle
    // It calls React re-render on calendar's select event, so while it doesn't work propely, it looks ok
    // When there is both time and date selects, we cannot use React's re-render on calendar's select event
    // because now there are two select events, one for date and one for time
    if(this.props.input_type === "datetime") {
      this.inputRef.current.bulmaCalendar.on("hide", this.handleOnChange)
    }else{
      this.inputRef.current.bulmaCalendar.on("select", this.handleOnChange)
    }
    // Listen for clear event when x button is clicked
    this.inputRef.current.bulmaCalendar.on("clear", this.handleClear)
  }

  shouldComponentUpdate = (nextProps, nextState) => {
    if(this.props.input_type != "datetime") {
      this.inputRef.current.bulmaCalendar.startDate = nextProps.value
      this.inputRef.current.bulmaCalendar.save()
    }
    return true
  }

  componentDidUpdate(prevProps) {
    // datetime mode skips startDate sync (see shouldComponentUpdate), so when
    // the value arrives after mount — e.g. an edit form whose data HOC sets
    // formData on the render *after* dataFetched — we have to push it through
    // the calendar's API explicitly.
    if (this.props.input_type !== "datetime") return
    if (prevProps.value === this.props.value) return
    const seed = parseValue(this.props.value)
    if (!seed) return
    this.inputRef.current.bulmaCalendar.value(seed)
    this.inputRef.current.bulmaCalendar.save()
  }

  handleOnChange = ({data}) => {
    const date = data.value()
    if(this.props.input_type === "datetime") {
      this.inputRef.current.bulmaCalendar.value(date)
      this.inputRef.current.bulmaCalendar.save()
    }
    this.setState({date})
    this.props.onChange(date)
  }

  handleClear = () => {
    this.setState({date: null})
    this.props.onChange(null)
  }

  render() {
    return(
      <div className="DatePicker field">
        <div>
          { this.props.label && <label className="label block">{ this.props.label }</label>}

          <input
            ref={this.inputRef}
            type={this.props.input_type || "date"}
            className="input"
            onChange={this.handleOnChange}
            placeholder={this.props.placeholder}
            value={ this.props.value || moment().format("MMM D yyyy")}
          />
        </div>
      </div>
    )
  }
}
